import type { CommitmentLineItem, FixedLineItem, LineItem, UsageLineItem } from '@weft/types';
import { isProductLineItem } from '..';
import { isFixedProduct,
  isUsageProduct,
  isCommitmentProduct,
  isTiersUsageProductOnly,
  isPerUnitUsageProductOnly, 
  isTiersVolumeProduct, 
  isCommissionProduct } from '../../products-filter';

// TODO: Move these types here (from where they are better implemented on pricing)
export function filterFixedLineItems(lineItems: LineItem[]): lineItems is FixedLineItem[] {
  return lineItems.every(isFixedLineItem);
}

export function filterUsageLineItems(lineItems: LineItem[]): lineItems is UsageLineItem[] {
  return lineItems.every(isUsageLineItem);
}

export function isFixedLineItem(lineItem: LineItem): lineItem is FixedLineItem {
  return isProductLineItem(lineItem) && isFixedProduct(lineItem.lineItemProduct);
}

export function isUsageLineItem(lineItem: LineItem): lineItem is UsageLineItem {
  if (!isProductLineItem(lineItem)) {
    return false;
  }

  return isUsageProduct(lineItem.lineItemProduct) && !isCommitmentProduct(lineItem.lineItemProduct);
}

export function isTiersUsageLineItem(lineItem: LineItem): lineItem is UsageLineItem {
  return isProductLineItem(lineItem) && isTiersUsageProductOnly(lineItem.lineItemProduct) && !isCommitmentProduct(lineItem.lineItemProduct);
}

export function isPerUnitLineItem(lineItem: LineItem): lineItem is UsageLineItem {
  return isProductLineItem(lineItem) && isPerUnitUsageProductOnly(lineItem.lineItemProduct) && !isCommitmentProduct(lineItem.lineItemProduct);
}

export function isCommitmentLineItem(lineItem: LineItem): lineItem is CommitmentLineItem {
  return isConsumingUsageProduct(lineItem);
}

export function isLineItemWithUnits(lineItem: LineItem): lineItem is (UsageLineItem | CommitmentLineItem) {
  return isUsageLineItem(lineItem) || isCommitmentLineItem(lineItem);
}

export function validateLineItemWithUnits(lineItem: LineItem): asserts lineItem is UsageLineItem | CommitmentLineItem {
  if (!isLineItemWithUnits(lineItem)) {
    throw new Error('Line item is not a usage or commitment line item');
  }
}

export function isConsumingUsageProduct(lineItem: LineItem): lineItem is CommitmentLineItem {
  return isProductLineItem(lineItem) && isCommitmentProduct(lineItem.lineItemProduct);
}

export function isVolumeBasedTiersLineItem(lineItem: LineItem): lineItem is UsageLineItem {
  return isTiersUsageLineItem(lineItem) && isTiersVolumeProduct(lineItem.lineItemProduct);
}

export function isNonRelativeFixedLineItem(lineItem: FixedLineItem): lineItem is FixedLineItem {
  return !isCommissionProduct(lineItem.lineItemProduct);
}

export function isUsageOrCommitmentLineItem(lineItem: LineItem): lineItem is UsageLineItem | CommitmentLineItem {
  return isUsageLineItem(lineItem) || isCommitmentLineItem(lineItem);
}